var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16143",
    "data-name": "Rectangle 16143",
    width: 15,
    height: 15,
    transform: "translate(0 -0.343)",
    fill: "#f5d630"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15633",
    "data-name": "Group 15633",
    transform: "translate(0 0.343)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15426",
    "data-name": "Group 15426",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41213",
    "data-name": "Path 41213",
    d: "M7.337,14.657A7.328,7.328,0,1,1,14.65,7.321a7.328,7.328,0,0,1-7.314,7.337m-.3-8.172,0-.025c-.29.037-.582.06-.867.118-.092.019-.166.13-.248.2.082.068.154.171.248.2.485.137.507.173.415.689q-.193,1.078-.366,2.16a.828.828,0,0,0,.564.945,1.769,1.769,0,0,0,1.8-.376c.083-.08.1-.233.14-.352-.116.013-.233.023-.349.039-.176.025-.427.136-.508.061-.111-.1-.095-.345-.128-.529A.349.349,0,0,1,7.748,9.5c.126-.679.255-1.358.377-2.039.116-.647-.108-.927-.771-.973-.107-.007-.214,0-.321,0m.342-.752a.958.958,0,1,0-.936-1,.971.971,0,0,0,.936,1",
    transform: "translate(0 -0.001)",
    fill: "#f5d630"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/infoIcon.1799d8fc9be518d0bc1e769465957c22.svg";
export { ForwardRef as ReactComponent };